import styled from "styled-components";
import VirtualTable from "../../../components/custom/VirtualTable";
import { ChoiceEmployee, MessageGroupData, MessageGroupMember, MessageGroupMemberExtended } from "../../../globals/interfaces";
import { useState } from "react";
import GroupsTable from "./GroupsTable";
import ActionIcon from "../../../components/custom/ActionIcon";
import { AddGroupMember, CreateGroup, DeleteGroup, DeleteGroupMember, UpdateGroup } from ".";
import ModalManageGroups from "./ModalManageGroups";
import ModalAddToGroup from "./ModalAddToGroup";

export default function ManageGroups({
    groups,
    employees,
    selectedGroup,
    setSelectedGroup,
    createGroup,
    updateGroup,
    deleteGroup,
    addGroupMember,
    deleteGroupMember,
    tableIndex
}: {
    groups: Array<MessageGroupData>;
    employees: Array<ChoiceEmployee>;
    selectedGroup: MessageGroupData | undefined;
    setSelectedGroup: React.Dispatch<React.SetStateAction<MessageGroupData | undefined>>;
    createGroup: CreateGroup;
    updateGroup: UpdateGroup;
    deleteGroup: DeleteGroup;
    addGroupMember: AddGroupMember;
    deleteGroupMember: DeleteGroupMember;
    tableIndex?: number;
}) {

    const [modal, setModal] = useState(false);
    const [modalMembers, setModalMembers] = useState(false);
    const [isUpdatingGroup, setIsUpdatingGroup] = useState(false);
    const handleCreateUpate = (group?: MessageGroupData) => {
        if (group) {
            setSelectedGroup(group);
            setIsUpdatingGroup(true);
        } else {
            setIsUpdatingGroup(false);
        }
        setModal(true);
    }

    return (
        <FlexContainer>
            <div>
                <FlexBetween>
                    <h6>Groups</h6>
                    <ActionIcon
                        type={'add'}
                        onClick={handleCreateUpate}
                    />
                </FlexBetween>
                <GroupsTable
                    groups={groups}
                    setSelectedGroup={setSelectedGroup}
                    handleCreateUpate={handleCreateUpate}
                    tableIndex={tableIndex}
                />
            </div>
            <div>
                <FlexBetween>
                    <h6>Current Users</h6>
                    {
                        selectedGroup && (
                            <ActionIcon
                                type={'add'}
                                onClick={() => setModalMembers(true)}
                            />
                        )
                    }
                </FlexBetween>
                <VirtualTable
                    data={selectedGroup ? selectedGroup.members : []}
                    mapping={[{
                        name: 'Unit',
                        value: 's_unit'
                    }, {
                        name: 'Email',
                        value: 's_email',
                        customWidth: 300
                    }, {
                        name: 'First Name',
                        value: 's_first_name'
                    }, {
                        name: 'Last Name',
                        value: 's_last_name'
                    }, {
                        name: 'Job Title',
                        value: 's_job_title'
                    }, {
                        name: '',
                        value: 'fas fa-trash',
                        icon: true,
                        function: (item: MessageGroupMemberExtended) => selectedGroup && deleteGroupMember(selectedGroup?.id, item.id)
                    }]}
                    numRows={10}
                />
            </div>
            <ModalManageGroups
                modal={modal}
                setModal={setModal}
                isUpdatingGroup={isUpdatingGroup}
                selectedGroup={selectedGroup}
                createGroup={createGroup}
                updateGroup={updateGroup}
                deleteGroup={deleteGroup}
            />
            <ModalAddToGroup
                modal={modalMembers}
                setModal={setModalMembers}
                employees={employees}
                selectedGroup={selectedGroup}
                addGroupMember={addGroupMember}
                deleteGroupMember={deleteGroupMember}
            />
        </FlexContainer>
    );
}

const FlexContainer = styled.div`
    display: flex;
    gap: 100px;
`;

const FlexBetween = styled.div`
    display: flex;
    justify-content: space-between;
`;